angular
    .module("skillBuilderSaaS")
    .filter("sbHtmlToPlainText", function () {
    return function (html) {
        return html ? String(html).replace(/<[^>]+>/gm, "") : "";
    };
});
